import { render, staticRenderFns } from "./DefaultPayrunCreateModal.vue?vue&type=template&id=1152da8f&scoped=true"
import script from "./DefaultPayrunCreateModal.vue?vue&type=script&lang=js"
export * from "./DefaultPayrunCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152da8f",
  null
  
)

export default component.exports